export const AVO_BUSINESS_SEND_CONTACT_EMAIL_REQUEST = 'AVO-BUSINESS/AVO_BUSINESS_SEND_CONTACT_EMAIL/REQUEST';
export const AVO_BUSINESS_SEND_CONTACT_EMAIL_RECEIVED = 'AVO-BUSINESS/AVO_BUSINESS_SEND_CONTACT_EMAIL/RECEIVED';

export const AVO_BUSINESS_ERROR = 'AVO-BUSINESS/ERROR';
